import script from "./LegacyOfferList.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegacyOfferList.vue?vue&type=script&setup=true&lang=ts"

import "./LegacyOfferList.vue?vue&type=style&index=0&id=f7c6c108&lang=scss"

const __exports__ = script;

export default __exports__